import React from "react";

export function Icon({ children }: { children: string }) {
  return <span className="icon material-icons-outlined">{children}</span>;
}
